import { render, staticRenderFns } from "./BillingOnTakePaymentModal.vue?vue&type=template&id=01030510&scoped=true&"
import script from "./BillingOnTakePaymentModal.vue?vue&type=script&lang=js&"
export * from "./BillingOnTakePaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01030510",
  null
  
)

export default component.exports